export const USER_DATA_QUERY_KEY = ['userData'] as const;
